import React, {useCallback, useMemo} from "react";
import {RoleNameEnum} from "../../../../utils/types/common";
import {readableRole} from "../../../../atoms/list-table/helpers";
import {PermissionsManagementFilterDropdown} from "./PermissionsManagementFilterDropdown";
import {PermissionsManagementFilterSelectorWrapper} from "./permissionsManagementFilters.styles";

type Props = Readonly<{
  availableRoles: ReadonlyArray<RoleNameEnum>;
  selectedRoles: ReadonlyArray<RoleNameEnum>;
  onRolesChange: (roles: ReadonlyArray<RoleNameEnum>) => void;
}>;

export const PermissionsManagementRoleFilter = ({
  availableRoles,
  selectedRoles,
  onRolesChange,
}: Props) => {
  const treeData = useMemo(
    () => [
      {
        key: "roles",
        title: "",
        checkable: false,
        className: "permissions-management-filter-group",
        children: availableRoles.map(role => ({
          key: role,
          title: readableRole(role),
        })),
      },
    ],
    [availableRoles],
  );

  const handleCheck = useCallback(
    (_: string[], checkedLeafKeys: string[]) => {
      onRolesChange(checkedLeafKeys as RoleNameEnum[]);
    },
    [onRolesChange],
  );

  return (
    <PermissionsManagementFilterSelectorWrapper>
      <PermissionsManagementFilterDropdown
        checkedKeys={[...selectedRoles]}
        triggerLabel="Role"
        onCheck={handleCheck}
        treeData={treeData}
        withApplyFiltersButton
      />
    </PermissionsManagementFilterSelectorWrapper>
  );
};
